<template>
  <div class="dynamic-dynamic">
    <div class="dynamic-list">
      <div class="dynamic-item" v-for="rec in records" :key="rec.id">
        <div class="date-wrap">
          <div class="day">{{ rec.day }}</div>
          <div class="date">{{ rec.date }}</div>
        </div>
        <el-avatar :size="40" :src="`${$fileBaseUrl}/40x40/${rec.createUserLogo}`">
          <img :src="`${$ssoUrl}/images/user/logo.png`" />
        </el-avatar>
        <div class="info">
          <div class="name-state">
            <span class="cust-name">{{ rec.operateUserName }}</span>
            <span class="state-name">{{ rec.operateTypeName }}</span>
          </div>
          <div class="time">{{ rec.lastModificationTime }}</div>
          <div class="remark">{{ rec.operateContent }}</div>
        </div>
      </div>
    </div>
    <pagination :total="total" :pageIndex="pageIndex" :pageSize="pageSize" :sizeChange="sizeChange" :currentChange="currentChange" />
    <div class="no-data" v-if="records.length === 0"></div>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";
export default {
  name: "detail-dynamic",
  props: {
    id: String,
    getLogs: Function,
  },
  data() {
    return {
      records: [],
      pageSize: 20,
      pageIndex: 1,
      total: 0,
    };
  },
  mounted() {
    this.getDynamicLogs();
  },
  methods: {
    getDynamicLogs() {
      this.getLogs(this.id, this.pageIndex, this.pageSize).then((res) => {
        this.records = res.data.map((i) => {
          const time = i.creationTime;
          if (time) {
            i.day = time.slice(8, 10);
            i.date = time.slice(0, 7);
          }
          return i;
        });
        this.total = res.dataCount;
      });
    },
    currentChange(page) {
      this.pageIndex = page;
      this.getDynamicLogs();
    },
    sizeChange(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.getDynamicLogs();
    },
  },
  components: { Pagination },
};
</script>

<style scoped lang="scss">
.dynamic-dynamic {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dynamic-list {
  flex: 1;
  overflow: auto;
  // margin-bottom: 10px;
  // border-bottom: 1px solid #e8e8e8;
}
.dynamic-item {
  display: flex;
  padding: 15px 0;
  font-size: 14px;
  border-bottom: 1px solid #e9e9e9;

  .date-wrap {
    padding-right: 24px;
    text-align: center;
    color: #666;
    .day {
      font-size: 20px;
      line-height: 1.2;
    }
    .date {
      font-size: 12px;
    }
  }
  .info {
    flex: 1;
    padding-left: 10px;
    line-height: 1.8;
    .name-state {
      display: flex;
      align-items: center;
    }
    .state-name {
      color: #2c68ff;
      background-color: #e4f0ff;
      font-size: 12px;
      padding: 0 6px;
      border-radius: 2px;
      margin-left: 12px;
    }
    .time {
      font-size: 12px;
      color: #666666;
    }
    .remark {
      color: #000;
      font-weight: bold;
      line-height: 1.5;
      margin-top: 5px;
    }
  }
}
</style>
